import gql from 'graphql-tag'

export const GET_CASH_BOX_SOURCE_PAGINATION_QUERY = gql`
  query GetCashBoxSourcePagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getCashBoxSourcePaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        static
        category {
          id
          title
        }
        type
        price
        currencyTitle
        title
      }
    }
  }
`
